<template>
  <div class="container bgWhite">
    <b-row>
      <b-col sm="12" class="float-right">
        <b-card>
          <b-button
            class="btn btn-lg float-right"
            type="submit"
            variant="primary"
            v-on:click="PrintSection"
          >
            <i class="fa icon-printer"></i> Cetak
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <div id="printSection">
      <br>
      <div style="text-align: center">
        <img
          src="../assets/media/logoMara1.png"
          border="0"
          width="100"
          height="125"
        />
      </div>
      <br>
      <div style="text-align: center">
        <h6 class="center">
          <strong>SLIP TAWARAN TEMUDUGA</strong>
        </h6>
      </div>
      <br>
      <div style="text-align: center">
        <h6 class="center">
          <strong>YOUNG TALENT DEVELOPMENT PROGRAMME (YTP)</strong>
        </h6>
      </div>
      <div class="card-body">
        <div>
          <div class="clearfix"></div>
          <table class="wrap-table ml-5">
            <tbody>
              <tr style="vertical-align:top;">
                <td class="title">
                  <span><strong>NAMA</strong></span>
                </td>
                <td class="title">:
                </td>
                <td class="title"></td>
                <td class="title">
                  <span style="text-transform: uppercase">{{ FirstName }}</span>
                </td>
              </tr>
              <tr>
                <td style="width: 200px" class="title">
                  <strong>NO KAD PENGENALAN</strong>
                </td>
                <td class="title">:
                </td>
                <td class="title"></td>
                <td class="title">
                  {{ IdentityNo }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br>
        <div class="ml-5">
          <span>
            TAHNIAH! Anda telah terpilih untuk hadir ke sesi pemilihan bagi YOUNG TALENT DEVELOPMENT PROGRAMME (YTP) seperti berikut:
          </span>
        </div>
        <br>
        <div class="ml-5">
          <div>
            <div class="clearfix"></div>
            <table class="wrap-table ml-5">
              <tbody>
                <tr>
                  <td class="title">
                    <span><strong>TARIKH</strong></span>
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title">:
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title">
                    <span>{{InterviewDate}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    <strong>MASA PENDAFTARAN</strong>
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title">: 
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title">
                    <span v-if="null != InterviewStartTime">{{InterviewStartTime}} HINGGA {{InterviewEndTime}}</span>
                  </td>
                </tr>
                <tr>
                  <td class="title">
                    <span><strong>TEMPAT TEMUDUGA</strong></span>
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title">:
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title">
                    <span>{{InterviewCenterName}}</span>
                  </td>
                </tr>
                <tr style="vertical-align: top;">
                  <td class="title" style="text-align: left; width: 250px;">
                    <span><strong>ALAMAT TEMPAT TEMUDUGA</strong></span>
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title">:
                  </td>
                  <td class="title">
                    <span style="text-transform: uppercase"></span>
                  </td>
                  <td class="title" style="white-space: pre-wrap">
                    <span>{{InterviewCenterAddress}}</span>
                    <!--
                    <span>{{InterviewCenter.Address1}}<br>{{InterviewCenter.Address2}}<br>{{InterviewCenter.Address3}}<br>{{InterviewCenter.Postcode}}<br>{{InterviewCenter.City}}<br>{{InterviewCenter.State}}</span>
                    -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <br>
        <div class="ml-5"><span>PERHATIAN: </span></div>
        <br>
        <div class="ml-5">
          <div>
            <div class="clearfix"></div>
            <table class="wrap-table ml-5 mr-5">
              <tbody>
                <tr>
                  <td align="left" style="vertical-align: top; width: 30px;">
                    <span>1.</span>
                  </td>
                  <td align="justify">
                    <span>
                      Calon dikehendaki hadir pada masa, tarikh dan tempat yang telah ditetapkan. Sila sediakan dokumen berikut semasa menghadiri sesi temuduga:
                    </span>
                    <table>
                      <tr>
                        <td>(i)</td>
                        <td>Kad Pengenalan Pelajar</td>
                      </tr>
                      <tr>
                        <td>(ii)</td>
                        <td>Slip Tawaran Temuduga</td>
                      </tr>
                      <tr>
                        <td>(iii)</td>
                        <td>Buku nota dan alat tulis</td>
                      </tr>
                    </table>
                    <br>
                  </td>
                </tr>
                <tr>
                  <td align="left" style="vertical-align: top; width: 30px">
                    <span>2.</span>
                  </td>
                  <td align="justify">
                    <span>
                      Calon dikehendaki berpakaian kemas, lelaki berbaju kemeja lengan panjang, perempuan berbaju kurung semasa menghadiri sesi temuduga.
                    </span>
                    <br>
                    <br>
                  </td>
                </tr>
                <tr>
                  <td align="left" style="vertical-align: top; width: 30px">
                    <span>3.</span>
                  </td>
                  <td align="justify">
                    <span>
                      Sebarang permohonan untuk menukar masa, tarikh dan tempat yang telah ditetapkan <strong>TIDAK</strong> akan dibenarkan.
                    </span>
                    <br>
                    <br>
                  </td>
                </tr>
                <tr>
                  <td align="left" style="vertical-align: top; width: 30px">
                    <span>4.</span>
                  </td>
                  <td align="justify">
                    <span>
                      Calon yang tidak dapat menghadiri sesi temuduga seperti yang telah ditetapkan oleh MARA dianggap <strong>MENOLAK</strong> tawaran ini.
                    </span>
                    <br>
                    <br>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br>
      <div class="ml-5"><span class="ml-4">Sekian, terima kasih.</span></div>
      <br>
      <div class="ml-5">
        <strong><span class="ml-4">"MALAYSIA MADANI"</span></strong>
      </div>
      <div class="ml-5">
        <strong><span class="ml-4">"BERKHIDMAT UNTUK NEGARA"</span></strong>
      </div>
      <div class="ml-5">
        <strong><span class="ml-4">"LUAR BANDAR SEJAHTERA"</span></strong></div>
      <br>
      <div class="ml-5"><span class="ml-4">Saya yang menjalankan amanah,</span></div>
      <br>
      <div class="ml-5"><span class="ml-4">PENGARAH</span></div>
      <div class="ml-5"><span class="ml-4">BAHAGIAN PENGANJURAN PELAJARAN</span></div>
      <div class="ml-5"><span class="ml-4">MARA</span></div>
      <br>
      <br>
      <div class="text-center">
        <span>Surat ini merupakan cetakan komputer dan tidak memerlukan tandatangan</span>
      </div>
    </div>
  </div>
</template>

<script>
import DefaultOption from "./DefaultOption";
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));

export default {
  name: "PersonalDetails",
  components: {
    DefaultOption,
  },
  props: ["appId"],
  data: function () {
    return {
      Error: false,
      Message: "",

      AppId: 0,
      Course1Code: "",
      Course1Name: "",
      FieldId: 0,
      FieldName: "",
      FirstName: "",
      IdentityNo: "",
      InstituteId: 0,
      InstituteName: "",
      InstituteNameOther: "",
      Intake: 0,
      InterviewCenter: {},
      InterviewCenterAddress: null,
      InterviewCenterAddress1: null,
      InterviewCenterAddress2: null,
      InterviewCenterAddress3: null,
      InterviewCenterName: null,
      InterviewCenterPostcode: null,
      InterviewDate: null,
      InterviewEndDt: null,
      InterviewEndTime: null,
      InterviewStartDt: null,
      InterviewStartTime: null,
      InterviewZoneName: null,
      ProgrammeCode: "",
      ProgrammeName: "",
      offerAcceptStartDate: null,

      StatusHistory: {},
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      await this.GetPersonalDetails();
      await this.GetIntakes();
      await this.GetProposedStudy();
      await this.GetStatusHistory();
    }
  },
  computed: {
    FilteredStatusHistory: {
      get: function () {
        let arr = this.StatusHistory;

        if (this.StatusHistory.length > 0) {
          arr = _.filter(arr, (status) => {
            return status.TypeId == 2;
          });
        }
        return arr;
      },
    },
    PrintDate: {
      get: function () {
        if (this.FilteredStatusHistory[0] != null)
          return this.moment(this.FilteredStatusHistory[0].CreatedDt).format(
            "DD/MM/YYYY"
          );
      },
    },
    PrintTime: {
      get: function () {
        if (this.FilteredStatusHistory[0] != null)
          return this.moment(this.FilteredStatusHistory[0].CreatedDt).format(
            "hh:mm A"
          );
      },
    },
  },
  methods: {
    PrintSection() {
      this.$htmlToPaper("printSection");
    },
    GetPersonalDetails() {
      return this.$API
        .get(this.$PersonalDetails, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.AppId = this.info.AppId;
            this.IdentityNo = this.info.IdentityNo;
            this.FirstName = this.info.FirstName;
          } else {
            this.Message = "Sila lengkapkan borang pendaftaran";
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Error = true;
            this.Message = error;
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GetIntakes() {
      return this.$API
        .get(this.$IntakeAll, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.Intakes = this.info;
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
          }
        });
    },
    GetProposedStudy() {
      this.$API
        .get(this.$ProposedStudy, { withCredentials: true })
        .then((response) => {
          this.info = response.data;
          if (response.status == 200 && response.data != null) {
            console.log(JSON.stringify(response.data));
            this.InterviewZoneName = response.data.InterviewZoneName;
            if (0 < response.data.InterviewSessionId) {
              this.InterviewStartDt = response.data.InterviewStartDt;
              this.InterviewEndDt = response.data.InterviewEndDt;
              this.InterviewDate = this.moment(this.InterviewStartDt).format("DD/MM/YYYY");
              this.InterviewStartTime = this.moment(this.InterviewStartDt).format("hh:mm A");
              this.InterviewEndTime = this.moment(this.InterviewEndDt).format("hh:mm A");
              this.InterviewCenterName = response.data.InterviewCenterName;
              ///*
              this.InterviewCenterAddress = response.data.InterviewCenterAddress1
                                + ((0<response.data.InterviewCenterAddress2.length)?'\n' + response.data.InterviewCenterAddress2:'')
                                + ((0<response.data.InterviewCenterAddress3.length)?'\n' + response.data.InterviewCenterAddress3:'')
                                + '\n' + response.data.InterviewCenterPostcode
                                + '\n' + response.data.InterviewCenterCity
                                + '\n' + response.data.InterviewCenterState;
              //*/
              this.InterviewCenter.Address1 = response.data.InterviewCenterAddress1;
              this.InterviewCenter.Address2 = response.data.InterviewCenterAddress2;
              this.InterviewCenter.Address3 = response.data.InterviewCenterAddress3;
              this.InterviewCenter.Postcode = response.data.InterviewCenterPostcode;
              this.InterviewCenter.City = response.data.InterviewCenterCity;
              this.InterviewCenter.State = response.data.InterviewCenterState;
            }
            this.Intake = this.info.IntakeId;

            let arr = _.filter(this.Intakes, ["Id", this.Intake]);
            this.ProgrammeId = arr[0].ProgramId;
            this.ProgrammeName = arr[0].Name;
            this.offerAcceptStartDate = (this.moment(arr[0].OfferAcceptStartDt).locale("ms-my").format('DD MMMM YYYY'));

            this.InstituteId = this.info.InstituteId;

            if (this.InstituteId == 0)
              this.InstituteName = this.info.InstituteNameOther;
            else this.InstituteName = this.info.InstituteName;
            console.log(
              (this.InstituteNameOther = this.info.InstituteNameOther)
            );

            this.FieldId = this.info.FieldId;

            if (this.FieldId == 9999) this.FieldName = this.info.FieldNameOther;
            else this.FieldName = this.info.FieldName;

            this.Course1Id = this.info.Course1Id;

            if (this.Course1Id == 9999)
              this.Course1Name = this.info.CourseNameOther;
            else this.Course1Name = this.info.Course1Name;

            this.Course1Code = this.info.Course1Code;
          } else {
            console.log(this.info.detail);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.status);
            this.Message = "Sila lengkapkan borang pendaftaran";
          }
        });
    },
    GetStatusHistory() {
      return this.$API
        .get(this.$StatusHistory, { withCredentials: true })
        .then((response) => {
          this.info = response.data;

          if (response.status == 200 && this.info != null) {
            this.StatusHistory = this.info;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
